import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function AdminRoute({ children }) {
  const { user, isInitialized } = useAuth();
  
  if (!isInitialized) {
    return (
      <div className="loading-auth">
        <div className="loading-spinner"></div>
        <p>Checking permissions...</p>
      </div>
    );
  }
  
  const isAdmin = user?.roles?.some(role => role.roleName === "admin");
  
  if (!isAdmin) {
    console.warn('AdminRoute: Access denied - user is not admin');
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
}

export default AdminRoute;